import React from 'react';

interface SectionDividerProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export default function SectionDivider({ title, subtitle, action }: SectionDividerProps) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-3">
        <div className="w-1 h-5 bg-teal rounded-full" />
        <div>
          <h3 className="text-sm font-semibold text-text-primary">{title}</h3>
          {subtitle && <p className="text-xs text-text-secondary mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
